// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
// Делаем Bootstrap доступным глобально для Stimulus контроллеров
window.bootstrap = bootstrap
// import $ from "jquery"
// window.$ = $
// window.jQuery = $

import "@oddcamp/cocoon-vanilla-js"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import IMask from 'imask';

import AirDatepicker from 'air-datepicker';

// import I18n from "./i18n"; // наш модуль с переводами
// window.I18n = I18n;